import { ApolloLink } from '@apollo/client';

const appReleaseLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'creh-app-version': process.env.NEXT_PUBLIC_COMMIT_SHA,
    },
  }));

  return forward(operation);
});

export default appReleaseLink;
